import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';
import type {
  SmtReportingQuery,
  SmtReportingQueryResult,
} from '../../../packages/runtime/smt-reporting-contract.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;
type ReportingRuntime = Pick<BusinessRuntime, 'smtReporting'>;

export interface SmtReportingPortConfig {
  readonly operatorId: string;
  readonly now: () => string;
}

export interface SmtReportingPort {
  queryReporting(query:SmtReportingQuery):Promise<SmtReportingQueryResult>;
}

export function createSmtReportingPort(
  runtime:ReportingRuntime,
  config:SmtReportingPortConfig,
):SmtReportingPort {
  return {
    async queryReporting(query){
      return runtime.smtReporting.query(query,{
        actorId:config.operatorId,
        at:config.now(),
      });
    },
  };
}
